/* Calling the function to check the Diamond Price: Pre Cart Page */
var isPreCart = getParameterByName('preCart');
if(isPreCart === 'true') {
  checkDiamondPriceMatchedorNot();
}

/** ======= Get all diamond products-Cart =========== **/
function getDiamondProductFromCart() {
  var grabSelectedDiamondInfo = localStorage.getItem("selectedDiamondCompleteData")
  var selectedDiamond = JSON.parse(grabSelectedDiamondInfo)
  var vowProductInfo = {}
  if(selectedDiamond){
    vowProductInfo['diamond_productId'] = selectedDiamond.id.toString()
    vowProductInfo['diamond_variantId'] = selectedDiamond.variants[0].id.toString() 
    vowProductInfo['diamond_retailPrice'] = '$' + (selectedDiamond.variants[0].price)
    vowProductInfo['diamondTitle'] = selectedDiamond.title
  }
  return vowProductInfo;
}

/** ========= Checking Diamond Price ========= **/
function checkDiamondPriceMatchedorNot() {
  try {
    var diamondProductInfo = getDiamondProductFromCart()
    if (diamondProductInfo && diamondProductInfo.diamond_productId) {
      return fetch(`${portalApiUrl}/verify_diamond_price`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(diamondProductInfo)
      })
      .then(response => response.json())
      .then(function (res) {
        if (res && res.action && res.action == "remove") {
          jQuery("#bespokeModalPreCart").find(".cm-modal-title").text("The price of your diamond has changed.")
          jQuery("#bespokeModalPreCart").find(".cm-modal-subtitle").text("Please click continue to see the updated price.")
          jQuery("#bespokeModalPreCart").find(".cusCartButton").text("Continue")
          jQuery("#bespokeModalPreCart").addClass("open")
        }
      })
    }
  } catch (error) {
    console.log('An error occurred:', error);
  }
}